import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-presencial',
  templateUrl: './presencial.component.html',
  styleUrls: ['./presencial.component.scss']
})
export class PresencialComponent implements OnInit {

  control: any[] = [];
  notificaciones: any[] = [];
  keys: any[] = ['Horario',  '00:00',  '01:00',  '02:00',  '03:00',  '04:00',  '05:00', '06:00',  '07:00',
  '08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00',
  '16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'];

  constructor(public rest: RestService) {
    this.GetAlzistencia();
    this.GetNotificaciones();
  }

  ngOnInit() {}


  GetControl() {
    this.rest.getCtrlPresencial().subscribe( (data) => {
      console.log(data);
      this.control = data['data'];
    });
  }

  GetAlzistencia(){
    this.rest.GetAlzistencia().subscribe( (data) => {
      this.control = data['data'];
    });
  }

  GetNotificaciones() {

    this.rest.GetNotificaciones().subscribe( (data) => {

      this.notificaciones = data['data'];

    });
  }

}
